import { MAIN_FAQ } from '@smarty-nx/code-utils'
import { TRACKING_CATEGORIES } from '@smarty-nx/tracking'
import { Link } from 'react-router-dom'

import {
  DesktopMenuItems,
  GetAccountItemsParams,
  GetDesktopLoggedInItemsParams,
  GetOffersItemsParams,
  GetSupportItemsParams,
} from './DesktopMenu.types'
import { MenuItem } from '../mobile-menu/MobileMenu.types'

export const getAccountItems = ({
  isActivated,
  isNotInGroup,
  userHasUsage,
  userHasAgreement,
}: GetAccountItemsParams): MenuItem[] => [
  {
    id: 'account-settings-menu-item',
    label: 'Account settings',
    href: '/dashboard/settings',
    as: Link,
    isHidden: !isActivated,
  },
  {
    id: 'group-settings-menu-item',
    label: 'Group settings',
    href: '/dashboard/groups/members',
    as: Link,
    isHidden: isNotInGroup,
  },
  {
    id: 'payment-history-menu-item',
    label: 'Payment history',
    href: '/dashboard/payments',
    as: Link,
  },
  {
    id: 'usage-history-menu-item',
    label: 'Usage history',
    href: '/dashboard/usage-history',
    as: Link,
    isHidden: !userHasUsage,
  },
  {
    id: 'plan-agreement-menu-item',
    label: 'Plan agreement',
    href: '/dashboard/plan-agreement',
    as: Link,
    isHidden: !userHasAgreement,
    dataItemCategory: TRACKING_CATEGORIES.NAVIGATION,
    dataItemName: 'plan-agreement',
  },
]

export const getSupportItems = ({
  isActivated,
  marketingUrl,
  communityUrl,
}: GetSupportItemsParams): MenuItem[] => [
  {
    id: 'view-support-menu-item',
    label: 'View support',
    href: `${marketingUrl}contact`,
  },
  {
    id: 'help-article-menu-item',
    label: 'Help article',
    href: MAIN_FAQ,
  },
  {
    id: 'network-status-checker-menu-item',
    label: 'Network and status checker',
    href: `${marketingUrl}network-status-checker`,
    isHidden: !isActivated,
    dataItemCategory: TRACKING_CATEGORIES.NAVIGATION,
    dataItemName: 'network-status-checker',
  },
  {
    id: 'coverage-checker-menu-item',
    label: 'Coverage checker',
    href: `${marketingUrl}coverage-checker`,
    isHidden: !isActivated,
    dataItemCategory: TRACKING_CATEGORIES.NAVIGATION,
    dataItemName: 'coverage-checker',
  },
  {
    id: 'roaming-and-international-menu-item',
    label: 'Roaming & International',
    href: `${marketingUrl}roaming`,
    dataItemCategory: TRACKING_CATEGORIES.NAVIGATION,
    dataItemName: 'roaming',
  },
  {
    id: 'community-menu-item',
    label: 'Community',
    href: `${communityUrl}`,
    dataItemCategory: TRACKING_CATEGORIES.NAVIGATION,
    dataItemName: 'community',
    openOnNewPage: true,
  },
]

export const getOffersItems = ({
  isActivated,
  isAbandonedAccount,
  isNotInGroup,
  memberWithNickname,
}: GetOffersItemsParams): MenuItem[] => [
  {
    id: 'gift-card-menu-item',
    label: 'Bag up to £20',
    href: '/dashboard/referrals',
    as: Link,
    isHidden: !isActivated || memberWithNickname,
    dataItemCategory: TRACKING_CATEGORIES.NAVIGATION,
    dataItemName: 'refer-a-friend',
  },
  {
    id: 'add-sim-menu-item',
    label: 'Add a SIM and save 10%',
    href: '/dashboard/groups',
    as: Link,
    isHidden: !isNotInGroup,
    dataItemCategory: TRACKING_CATEGORIES.NAVIGATION,
    dataItemName: 'add-group-sim-menu',
  },
  {
    id: 'need-phone-menu-item',
    label: 'Need a phone?',
    href: '/dashboard/refurbished-phones',
    as: Link,
    isHidden: isAbandonedAccount,
    dataItemCategory: TRACKING_CATEGORIES.NAVIGATION,
    dataItemName: 'need-a-phone-menu',
  },
]

export const getDesktopLoggedInMenuItems = ({
  isActivated,
  isAbandonedAccount,
  isNotInGroup,
  userHasUsage,
  userHasAgreement,
  memberWithNickname,
  marketingUrl,
  communityUrl,
}: GetDesktopLoggedInItemsParams): DesktopMenuItems[] => [
  {
    id: 'account-sub-menu',
    name: 'My account',
    items: getAccountItems({
      isActivated,
      isNotInGroup,
      userHasUsage,
      userHasAgreement,
    }),
  },
  {
    id: 'support-menu-item',
    name: 'Support',
    items: getSupportItems({ isActivated, marketingUrl, communityUrl }),
  },
  {
    id: 'offers-sub-menu',
    name: 'Offers',
    items: getOffersItems({
      isActivated,
      isAbandonedAccount,
      isNotInGroup,
      memberWithNickname,
    }),
  },
]
